import { Button } from '@va/ui/design-system';
import { TEST_IDS } from '@va/constants';
import React from 'react';

type SeeMoreButtonProps = {
  text: string;
  onClick: () => void;
};

/**
 * Intended the bottom of the report blocks in the main dashboard
 */
export const SeeMoreButton = ({ text, onClick }: SeeMoreButtonProps) => {
  return (
    <Button
      data-testid={TEST_IDS.generic.buttons.seeMore}
      color='tertiary'
      className='w-full pt-3 !mt-auto shrink-0'
      onClick={onClick}
      text={text}
    />
  );
};
